import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_FAC040_Request,
  IAPI_FAC040_Response,
} from "../../../type/apiType/index";
import {
  IAPI_FAC041_Request,
  IAPI_FAC041_Response,
} from "../../../type/apiType/index";

// 施設廃止状況一覧参照API
const httpIAPI_FAC040 = async (
  param: IAPI_FAC040_Request
): Promise<IAPI_FAC040_Response> => {
  const res = await http.post(ApiUrl.API_FAC040, { ...param });
  return res.data;
};

// 廃止対象施設削除API
const httpIAPI_FAC041 = async (
  param: IAPI_FAC041_Request
): Promise<IAPI_FAC041_Response> => {
  const res = await http.post(ApiUrl.API_FAC041, {
    ...param,
  });
  return res.data;
};

export { httpIAPI_FAC040, httpIAPI_FAC041 };
